import { useState } from 'react';


        // ===== Keyword Picker =====
        // Reusable component for picking positive/negative keywords with
        // suggestion chips and free-text entry. Stores the value as a
        // comma-separated string to keep the parent form simple.
        function KeywordPicker({ label, value, onChange, suggestions, helpText, placeholder }) {
            const [draft, setDraft] = useState('');

            const splitList = (s) =>
                (s || '').split(',').map(x => x.trim()).filter(Boolean);

            const current = splitList(value);

            const addTerm = (term) => {
                const t = term.trim();
                if (!t) return;
                if (current.map(c => c.toLowerCase()).includes(t.toLowerCase())) return;
                onChange([...current, t].join(', '));
                setDraft('');
            };

            const removeTerm = (term) => {
                onChange(current.filter(c => c !== term).join(', '));
            };

            const onDraftKey = (e) => {
                // Comma or Enter commits the current draft as a chip
                if (e.key === ',' || e.key === 'Enter') {
                    e.preventDefault();
                    if (draft.trim()) addTerm(draft);
                }
            };

            // Suggestions minus the ones already chosen
            const remaining = (suggestions || []).filter(
                s => !current.map(c => c.toLowerCase()).includes(s.toLowerCase())
            );

            return (
                <div>
                    <label>{label}</label>

                    {/* Current chips */}
                    {current.length > 0 && (
                        <div className="flex flex-wrap gap-2 mb-2 mt-1">
                            {current.map(term => (
                                <span key={term} className="inline-flex items-center gap-2 px-2 py-1"
                                    style={{background: 'rgba(201,169,110,0.15)', color: 'var(--gold)',
                                            border: '1px solid var(--gold-dim)', borderRadius: '2px',
                                            fontSize: '12px', fontFamily: 'IBM Plex Mono, monospace'}}>
                                    {term}
                                    <button type="button" onClick={() => removeTerm(term)}
                                        className="text-muted hover:text-[var(--red)]"
                                        style={{lineHeight: '1', cursor: 'pointer'}}>×</button>
                                </span>
                            ))}
                        </div>
                    )}

                    {/* Free-text input */}
                    <input type="text"
                        value={draft}
                        onChange={(e) => setDraft(e.target.value)}
                        onKeyDown={onDraftKey}
                        onBlur={() => { if (draft.trim()) addTerm(draft); }}
                        placeholder={placeholder || 'Type, comma to add'} />

                    {helpText && <div className="text-xs text-muted mt-1">{helpText}</div>}

                    {/* Suggestion chips */}
                    {remaining.length > 0 && (
                        <div className="mt-2">
                            <div className="text-xs text-muted font-mono uppercase tracking-widest mb-1">Suggestions</div>
                            <div className="flex flex-wrap gap-2">
                                {remaining.map(s => (
                                    <button key={s} type="button"
                                        onClick={() => addTerm(s)}
                                        style={{background: 'transparent', color: 'var(--muted)',
                                                border: '1px dashed var(--gold-dim)', borderRadius: '2px',
                                                padding: '3px 8px', fontSize: '11px',
                                                fontFamily: 'IBM Plex Mono, monospace', cursor: 'pointer'}}>
                                        + {s}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            );
        }

export { KeywordPicker };
